module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_25.png?e2ac11cf5bd2d440f8e1f46a74cdf771";